var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$page.props.flash)?_c('b-alert',{attrs:{"variant":_vm.variant,"show":_vm.$page.props.flash.success || _vm.$page.props.flash.error}},[_vm._v("\n    "+_vm._s(_vm.$page.props.flash.success || _vm.$page.props.flash.error)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }